// extracted by mini-css-extract-plugin
module.exports = {"card":"expCard_card__2-prR","text":"expCard_text__CqmEX"};